import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_UI_LANGUAGE,
  isUiLanguage,
  persistUiLanguage,
  readStoredUiLanguage,
} from '@/lib/locale.js';
import { translationResources } from '@/locales/index.js';

function syncDocumentLanguage(language: string): void {
  if (typeof document !== 'undefined' && isUiLanguage(language)) {
    document.documentElement.lang = language;
  }
}

const initialLanguage = readStoredUiLanguage();

void i18n.use(initReactI18next).init({
  resources: Object.fromEntries(
    Object.entries(translationResources).map(([language, translation]) => [language, { translation }]),
  ),
  lng: initialLanguage,
  fallbackLng: DEFAULT_UI_LANGUAGE,
  supportedLngs: ['uk', 'en'],
  load: 'currentOnly',
  initAsync: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

syncDocumentLanguage(initialLanguage);

i18n.on('languageChanged', (language) => {
  if (!isUiLanguage(language)) return;
  persistUiLanguage(language);
  syncDocumentLanguage(language);
});

export default i18n;
